<template>
  <div :class="componentClassName">
    <section class="t-trial-entry__col t-trial-entry__col--login">
      <section class="t-trial__content">
        <div class="t-trial__composite-logo">
          <a id="composite" :href="compositeUrl" target="_blank">
            <img src="@/images/composite_yoko_rgb_color.svg" />
          </a>
        </div>
        <h1 class="t-trial__logo"><img src="@/images/cotoha-call-center-logo-horizontal.svg" /></h1>

        <div class="t-tab__panel">
          <!--タブ-->

          <div class="t-tab__coment">無料トライアルのお申し込みからご利用までの流れ</div>
          <ul class="t-tab__group">
            <li class="t-tab tab-free" :class="{ 'is-active': tabNo[0] }" @click="tabSwitch(0)">
              無料トライアル<br />について
            </li>
            <li class="t-tab t-tab__application" :class="{ 'is-active': tabNo[1] }" @click="tabSwitch(1)">
              <span>1.</span>お申し込み
            </li>
            <li class="t-tab t-tab__login" :class="{ 'is-active': tabNo[2] }" @click="tabSwitch(2)">
              <span>2.</span>サービスへ<br class="t-tab__br" />のログイン
            </li>
            <li class="t-tab t-tab__start" :class="{ 'is-active': tabNo[3] }" @click="tabSwitch(3)">
              <span>3.</span>トライアル<br class="t-tab__br" />利用の開始
            </li>
          </ul>

          <!--タブを切り替えて表示するコンテンツ-->
          <div class="t-panel__group">
            <div class="t-panel tab-free" :class="{ 't-is__show': tabNo[0] }">
              <div class="t-trial__fcontent">
                <div class="t-trial__fbox">
                  <p class="t-trial__fbox__top">無料トライアル利用期間</p>
                  <p class="t-trial__fbox__bottom">お申し込みから<span class="t-trial__forange">14日間</span></p>
                </div>
                <div class="t-trial__fbox">
                  <p class="t-trial__fbox__top">利用できる最大アカウント数</p>
                  <p class="t-trial__fbox__bottom">
                    <span class="t-trial__forange">3<span class="t-trial__fsize">ID</span></span>
                  </p>
                </div>
              </div>
              <p class="t-trial__ftitle">注意事項</p>
              <ul class="t-trial__list">
                <li class="t-trial__li">
                  <span
                    >利用期間終了後、トライアルは自動的に解約され、本契約に移行することはありませんのでご安心ください。</span
                  >
                </li>
                <li class="t-trial__li">
                  <span>外線機能、AIオペレータ機能は本トライアルにおいてはご利用いただけません。</span>
                </li>
                <li class="t-trial__li">
                  <span
                    >サービスのトライアルを利用するためのインターネット環境及びパソコンはお客様自身でご準備ください。</span
                  >
                </li>
              </ul>

              <div class="mb inquiry">
                <p class="t-inquiry__subtitle"><span>ご不明な点、お気軽にお問い合わせください</span></p>
                <div class="t-inquiry__border">
                  <div class="t-m__rbox">
                    <p class="t-inquiry__title"><img src="@/images/pages/tell.svg" />0120-51-8506</p>
                    <p class="t-inquiry__text">
                      受付時間：9:00～17:00<br class="spnone" />　受付日：平日(土日祝を除く)
                    </p>
                  </div>
                  <div class="t-m__bbox">
                    <a
                      href=" https://forms.office.com/pages/responsepage.aspx?id=Mu8pprpnpkeOs-xDk1ZE_DJiC9_Rv4hHpPI0f7FZCqdUMEhPM0VSQjgzTUpCWU1YMDkyT0JHNFNYVi4u "
                      target="_blank"
                      >フォームで<br class="spnone" />お問い合わせをする</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="t-panel t-tab__application" :class="{ 't-is__show': tabNo[1] }">
              <p class="trial-text">
                画面右側「お申し込み」ボタンよりお申し込みフォームへ進み、<br />
                氏名・電話番号・メールアドレスを入力してください。<br />
                お申し込み後、お客さまにご登録いただいたメールアドレス宛てに即時トライアル用の契約ID・ID（お申し込みいただいたメールアドレス）・初期パスワード・サービスのログインページURLをお送りします。
              </p>
              <div class="t-trial__img">
                <img src="@/images/pages/trial02.svg" />
              </div>
              <p class="t-attention">※上記メールが確認できない場合は、一度迷惑メールフォルダをご確認ください。</p>
              <p class="t-attention">
                ※それでもメールを確認できない場合などは、<a
                  href=" https://forms.office.com/pages/responsepage.aspx?id=Mu8pprpnpkeOs-xDk1ZE_DJiC9_Rv4hHpPI0f7FZCqdUMEhPM0VSQjgzTUpCWU1YMDkyT0JHNFNYVi4u"
                  target="_blank"
                  >こちら</a
                >よりお問い合わせください。
              </p>
            </div>
            <div class="t-panel t-tab__login" :class="{ 't-is__show': tabNo[2] }">
              <p class="trial-text">
                メールに記載のサービスのログインページURLへアクセスし、ログインページに、
                メールに記載の契約ID・ID（お申込みいただいたメールアドレス）・初期パスワードを入力して、
                ログインボタンを押します。<br />
                詳しい手順は<a
                  href=" https://cotoha-call-center-manual.notion.site/91b58bdd80114ec58cd4f0ac2b5c2aa4"
                  target="_blank"
                  >こちら</a
                >をご確認ください。
              </p>
              <div class="t-trial__img">
                <img src="@/images/pages/trial03.svg" />
              </div>
            </div>
            <div class="t-panel t-tab__start" :class="{ 't-is__show': tabNo[3] }">
              <p class="trial-text">
                お手持ちのパソコンでの通話品質の確認や自動音声ガイダンス・IVR・電話帳・ユーザー管理等の
                基本機能の操作を行うことが可能です。
              </p>
              <p class="trial-text t-start__ds">
                <span>※</span
                ><span
                  >トライアル環境へユーザーを追加（ID追加）することでユーザー間の内線通話が可能となり、 COTOHA Call
                  COTOHA Call Centerを通じた電話の受発信を試すことができます。</span
                >
              </p>
              <div class="t-trial__img">
                <img src="@/images/pages/trial04.svg" />
              </div>
              <!-- <div　class="trial-attention"> -->
              <p class="t-attention t-ta__c">
                ※各種設定方法の詳細はサービスの<a
                  href=" https://cotoha-call-center-manual.notion.site/cotoha-call-center-manual/COTOHA-Call-Center-2d322656d90e4804b840a3e37c36ec3d"
                  target="_blank"
                  >マニュアル</a
                >を参照ください。
              </p>
              <!-- </div> -->
              <div class="mb inquiry">
                <p class="t-inquiry__subtitle"><span>ご不明な点、お気軽にお問い合わせください</span></p>
                <div class="t-inquiry__border">
                  <div class="t-m__rbox">
                    <p class="t-inquiry__title"><img src="@/images/pages/tell.svg" />0120-51-8506</p>
                    <p class="t-inquiry__text">受付時間：9:00～17:00<br class="spnone" />受付日：平日(土日祝を除く)</p>
                  </div>
                  <div class="t-m__bbox">
                    <a
                      href=" https://forms.office.com/pages/responsepage.aspx?id=Mu8pprpnpkeOs-xDk1ZE_DJiC9_Rv4hHpPI0f7FZCqdUMEhPM0VSQjgzTUpCWU1YMDkyT0JHNFNYVi4u"
                      target="_blank"
                      >フォームで<br class="spnone" />お問い合わせをする</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>

    <section class="t-trial-entry__col">
      <div class="t-trial-entry__form-wrapper" style="margin-top: 0">
        <a-heading
          class="t-trial-entry__heading"
          tag="h1"
          variant="center"
          :heading="heading"
          :subheading="subHeading"
        />
        <a-section-divider />

        <div class="t-trial-entry__body">
          <slot></slot>
        </div>
      </div>

      <o-global-footer class="t-trial-entry__footer">
        <m-link-container>
          <template v-for="(item, index) in navigationItems" :key="index">
            <li>
              <a-button variant="text" size="small" :href="item.link">{{ item.label }}</a-button>
            </li>
          </template>
        </m-link-container>
      </o-global-footer>
    </section>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import MLinkContainer from '@/components/molecules/link-container';
import OGlobalFooter from '@/components/organisms/global-footer';

export default {
  name: 't-trial-default-entry',
  components: {
    MLinkContainer,
    OGlobalFooter,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    class: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      default: null,
    },
    subHeading: {
      type: String,
      default: null,
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    activeNavId: {
      type: String,
      default: '',
    },
    compositeUrl: {
      type: String,
      default: 'https://www.ntt.com',
    },
  },
  data() {
    return {
      tabNo: [3],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-trial-entry');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    this.tabSwitch(0);
  },
  methods: {
    tabSwitch(type) {
      for (let i = 0; i < this.tabNo.length; i++) {
        this.tabNo[i] = false;
      }
      this.tabNo[type] = true;
    },
  },
};
</script>
